<template>
    <div>
        <h3>定向发放优惠券</h3>
        <el-form size="mini" label-width="180px" class="demo-form-inline" :model="formData" :rules="rules" ref="formData">
            <el-form-item label="优惠券活动ID">{{aid}}</el-form-item>
            <el-form-item label="优惠券活动名称">{{activityInfo.activityName}}</el-form-item>
            <el-form-item label="填写用户ID" prop="userIds">
                <el-input type="textarea" v-model="formData.userIds" :rows="5" placeholder="定向为用户发放优惠券，需填写用户id，多个id用‘#’分隔" />
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit">立即发放</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import map from '../../datamap'
import api from '../api'

const {
    coupon,
} = api

export default {
    name: "couponAssign",
    data() {
        return {
            formData: {
                userIds: '',
            },
            activityInfo: {},
            rules: {
                userIds: [{
                    required: true,
                    message: '请输入用户ID',
                    trigger: 'blur'
                }],
            },
            isSubmiting: false,
        }
    },
    computed: {
        aid() {
            return this.$route.params.aid || '';
        },
    },
    watch: {},
    created() {
        if (this.aid) {
            this.getDetail();
        }
    },
    mounted() {},
    methods: {
        async getDetail() {
            let obj = {
                id: this.aid
            }
            let {
                data: {
                    code,
                    data,
                }
            } = await api.coupon.detail(obj)
            if (code == 200) {
                this.activityInfo = data;
            }
        },
        submit() {
            this.$refs.formData.validate(valid => {
                if (valid) {
                    this.$confirm('是否确认发放优惠券', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '再想想',
                        type: 'warning'
                    }).then(async () => {
                        if (this.isSubmiting) return false;
                        this.isSubmiting = true;
                        let obj = this.formData;
                        obj.activityName = this.activityInfo.activityName;
                        let {
                            data: {
                                code,
                                data,
                            }
                        } = await api.coupon.assign(obj);
                        let vue = this;
                        if (code == 200) {    
                            this.$message({
                                showClose: false,
                                message: '发放成功',
                                type: 'success',
                                onClose() {
                                    window.location.href = `/activities`; 
                                }
                            })
                        }
                        this.isSubmiting = false;
                    }).catch((e) => {
                        this.isSubmiting = false;
                        if (e === 'cancel') {
                            this.$message({
                                type: 'info',
                                message: '已取消'
                            });
                        } else {
                            this.$message({
                                type: 'error',
                                message: '发放失败'
                            });
                        }
                    });
                } else {
                    return false;
                }
            })
        },
    },
};
</script>
<style scoped>
.demo-form-inline {
    width: 680px;
}

.line {
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/views/coupon/assign.vue